export function Spinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 p-8" role="status" aria-live="polite">
      <span className="size-5 animate-spin rounded-full border-2 border-signal border-t-transparent" />
      <span className="text-sm text-ink-800">{label}</span>
    </div>
  );
}
